import { formatDurationHms } from '@/utils/formatters';
import type { ProjectAggregate } from '@/features/reports/utils/aggregateTasks';

interface ProjectBreakdownProps {
  projects: ProjectAggregate[];
  totalMinutes: number;
}

export function ProjectBreakdown({ projects, totalMinutes }: ProjectBreakdownProps) {
  const totalHours = totalMinutes / 60;

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-[1fr_auto_auto] gap-2 border-b pb-2 text-xs font-medium text-muted-foreground">
        <span>Project</span>
        <span className="text-right">Hours</span>
        <span className="text-right">%</span>
      </div>

      {projects.map((project) => {
        const percent = totalHours > 0 ? Math.round((project.hours / totalHours) * 100) : 0;
        return (
          <div
            key={project.projectId}
            className="grid grid-cols-[1fr_auto_auto] gap-2 items-center text-sm"
          >
            <div className="flex items-center gap-2">
              <span
                className="h-2.5 w-2.5 rounded-full"
                style={{ backgroundColor: project.color ?? 'hsl(var(--primary))' }}
              />
              <span className="truncate font-medium text-foreground">{project.projectName}</span>
            </div>
            <span className="text-right text-muted-foreground">
              {formatDurationHms(Math.round(project.hours * 60))}
            </span>
            <span className="min-w-[3ch] text-right font-semibold text-foreground">
              {percent}%
            </span>
          </div>
        );
      })}

      <div className="grid grid-cols-[1fr_auto_auto] gap-2 items-center border-t pt-2 text-sm">
        <span className="font-semibold text-foreground">Total</span>
        <span className="text-right font-semibold text-foreground">{formatDurationHms(totalMinutes)}</span>
        <span className="min-w-[3ch] text-right font-semibold text-foreground">100%</span>
      </div>
    </div>
  );
}
